export default __webpack_public_path__ + "static/media/speech group button.80b990e0.svg";